// extracted by mini-css-extract-plugin
export default {"conversationWindow":"Home_conversationWindow__j+jHJ","overlay":"Home_overlay__RonVB","messagesWindow":"Home_messagesWindow__QlL7K"};